export const OPERACOES_PAGE = () => "/operacoes";
